import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { RolesEntity } from "../entities/roles.entity";




@Injectable()
export class RolesRepository extends Repository<RolesEntity>{
    constructor(private dataSource: DataSource) {
        super(RolesEntity, dataSource.createEntityManager());
    }

    async getRolesByApplicationId(applicationId:number){
        const queryData = await this.createQueryBuilder("r") // Use "u" alias for userEntity
        .select(`r.name,r.id`)
        .leftJoin('role_permissions','rp','rp.role_id = r.id')
        .leftJoin('permissions','p','p.id = rp.permission_id')
        .leftJoin('application','a','a.id = p.application_id')
        .where(`a.id = ${applicationId}`)
        .groupBy('r.id')
        .getRawMany();
    
        return queryData;
    }   
}